import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder normalen Stuhl. Wir sind so erleichtert.',
  author: 'Sandra (Hund: Balu, Labrador, 4 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=100&q=80'
}, {
  text: 'Balu hatte wochenlang ständigen Durchfall und weichen Kot. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.',
  author: 'Michael (Hund: Max, Schäferhund, 6 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1589941013453-ec89f33b5e95?w=100&q=80'
}, {
  text: 'Es hat so geholfen und gewirkt, wie sie es beschreiben. Nach zwei Wochen hatte unser Hund keine Beschwerden mehr.',
  author: 'Thomas (Hund: Luna, Mischling, 2 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?w=100&q=80'
}, {
  text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserem Labrador viel viel besser. Macht weiter so!',
  author: 'Julia (Hund: Charlie, Golden Retriever, 5 Jahre)',
  avatar: 'https://images.unsplash.com/photo-1552053831-71594a27632d?w=100&q=80'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-cream-dark border-y border-brown-light/20" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-142">
          <h2 className="font-handwriting text-4xl md:text-5xl text-forest mb-4" data-id="element-143">
            Nicht nur Balu geht es besser...
          </h2>
          <p className="font-serif text-lg text-brown-dark/70" data-id="element-144">
            Erfahrungen von anderen Hundebesitzern
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-145">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-brown-light/10 flex flex-col" data-id="element-146">
              <div className="flex items-center gap-4 mb-4" data-id="element-147">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-cream flex-shrink-0 border border-brown-light/20" data-id="element-148">
                  <img src={review.avatar} alt="Foto" className="w-full h-full object-cover" data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <div className="flex gap-1 mb-1" data-id="element-151">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-152" />)}
                  </div>
                  <p className="font-serif font-medium text-sm text-brown-dark/80" data-id="element-153">
                    {review.author}
                  </p>
                </div>
              </div>
              <p className="font-serif text-brown-dark/90 leading-relaxed" data-id="element-154">
                {review.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}